/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_TitleInputs */

const en_settings_apikeys_title = /** @type {(inputs: Settings_Apikeys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys`)
};

const zh_settings_apikeys_title = /** @type {(inputs: Settings_Apikeys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥`)
};

/**
* | output |
* | --- |
* | "API Keys" |
*
* @param {Settings_Apikeys_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_title = /** @type {((inputs?: Settings_Apikeys_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_title(inputs)
	return zh_settings_apikeys_title(inputs)
});
export { settings_apikeys_title as "settings.apikeys.title" }